import React, { useEffect, useState } from "react";
import styles from "./NewAgentSearchPage.module.scss";
import NewUIAgentSearchForm from "./NewUIAgentSearchFormHolidays";
import NewUIAgentSearchFormHolidays from "./NewUIAgentSearchFormHolidays";
import NewUIAgentSearchFormHotels from "./NewUIAgentSearchFormHotels";
import NewUIAgentSearchFormActivity from "./NewUIAgentSearchFormActivity";
import NewUIAgentSearchFormTransport from "./NewUIAgentSearchFormTransport";
import { animateScroll as scroll } from "react-scroll";
import {
  currentDateSingle,
  formatIndianCurrency,
  scrollToTop,
} from "../../../utils/utils";
import Skeleton from "react-loading-skeleton";
import imgNotFound from "../../../assets/images/single-image.png";
import HotelCard from "../NewUiHotels/HotelCard";
import NewUIPackageCard from "../NewUIPackages/NewUIPackageCard";
import NewSendEnquiryPopup from "../../NewSendEnquiryPopup/NewSendEnquiryPopup";
import { useLocation, useNavigate } from "react-router-dom";
import NoDataFound from "../../NoDataFound/NoDataFound";
import ActivityCard from "../NewUiActivities/ActivityCard";
import { DistanceMatrixService } from "@react-google-maps/api";
import CustomListingCardActivities from "../../CustomListingCardActivities/CustomListingCardActivities";
import Loader from "../../Loader/Loader";
import NewAgentPackageCard from "./NewAgentPackageCard";
import NewAgentActivityCard from "./NewAgentActivityCard";
import AgentSideBar from "../../../Pages/Agent/AgentSideBar/AgentSideBar";
import AgentHeader from "../../../Pages/Agent/AgentHeader/AgentHeader";
import CustomPagination from "../../CustomPagination/CustomPagination";

const NewAgentSearchPage = () => {
  const buttons = ["Packages", "Hotels", "Activities", "Transport"];
  const [activeButton, setActiveButton] = useState("Hotels");
  const location = useLocation();
  const [loader, setLoader] = useState(true);
  const [allHotelsData, setAllHotelsData] = useState([]);
  const [allPackagesData, setAllPackagesData] = useState([]);
  const [allActivitiesData, setAllActivitiesData] = useState([]);
  const [allTransportData, setAllTransportData] = useState([]);
  const [showSendEnquiryPopup, setShowSendEnquiryPopup] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [noOfDays, setNoOfDays] = useState(null);
  const navigate = useNavigate();

  const [includingDestinations, setIncludingDestinations] = useState([]);

  const [startDestination, setStartDestination] = useState("");
  const [date, setDate] = useState({
    setDay: "",
    setMonth: "",
    setYear: "",
  });

  const fetchAllHotels = async (data, filters) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    // myHeaders.append("key", "6rga76jtoA6Y5PPILhMAjn6nv95uHfRqR3Ykpu9GX4kw7lPpmM1");
    setLoader(true);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    const formdata = new FormData();
    formdata.append("checkIn", checkInDate);
    formdata.append("checkOut", checkOutDate);
    {
      data.adult && formdata.append("adults", data.adult);
    }
    {
      data.children && formdata.append("child", data.children);
    }
    {
      data.location && formdata.append("location", data.location);
    }
    formdata.append("rooms", data.room);
    formdata.append("PropertyType", data?.radio ? data?.radio : "hotel");
    {
      data.location && formdata.append("location", data.location);
    }
    if (data.children > 0) {
      for (let i = 1; i <= data.children; i++) {
        formdata.append(`childAge[${i - 1}]`, data.childAge[i - 1]);
      }
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/v1/hotel-engine/check-availability?star_rating=${
          filters?.stars ? filters?.stars : ""
        }&price_range=${filters?.budget ? filters?.budget : ""}`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setAllHotelsData(result?.data?.properties);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching properties:", error);
    }
  };

  const fetchAllPackages = async (data, filters) => {
    // console.log("filters", filters);
    setLoader(true);
    // setFilterLoader(true);
    const myHeaders = new Headers();
    // myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();
    {
      data.location &&
        formdata.append("location", data.location ? data.location : "");
    }
    formdata.append("guest", data.adult ? data.adult : 2);
    formdata.append("children", data.children ? data.children : 0);
    // Append childAge values dynamically
    if (data.children > 0) {
      for (let i = 1; i <= data.children; i++) {
        formdata.append(`childAge[${i - 1}]`, data.childAge[i - 1]);
      }
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch?destination=${
          filters?.destinations ? filters?.destinations : ""
        }&price_range=${filters?.budget ? filters?.budget : ""}&duration=${
          filters?.duration ? filters?.duration : ""
        }&theme=${filters?.themes ? filters?.themes : ""}`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
      setLoader(false);
      setAllPackagesData(result?.data);
      setLoader(false);
      scrollToTop();
    } catch (error) {
      setAllPackagesData([]);
      setLoader(false);
      console.error(error);
    } finally {
      // setFilterLoader(false);
    }
  };

  // const fetchAllActivities = async (data, filters) => {
  //   setLoader(true);
  //   const myHeaders = new Headers();
  //   myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
  //   const formdata = new FormData();

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/v1/activities/fetch`,
  //       requestOptions
  //     );
  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.statusText}`);
  //     }
  //     const result = await response.json();
  //     setAllActivitiesData(result.data);
  //     setLoader(false);
  //   } catch (error) {
  //     setLoader(false);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const fetchAllActivities = async (data, filters) => {
    setLoader(true);

    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();
    {
      data.location && formdata.append("location", data.location);
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/v1/activities/fetch?price_range=${
          filters?.budget ? filters?.budget : ""
        }&destination=${data?.multiple_destinations}`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
      setAllActivitiesData(result.data);
    } catch (error) {
      setAllActivitiesData([]);
      console.error(error);
    } finally {
      setLoader(false);
      scrollToTop();
    }
  };

  // const fetchAllTransport = async (data) => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/v1/transport-holidays/fetch`,
  //       {
  //         method: "POST",
  //         headers: {
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //           key: process.env.REACT_APP_BASE_API_KEY,
  //           Cookie: process.env.REACT_APP_COOKIE,
  //         },
  //         body: JSON.stringify({
  //           hub: "Chandigarh",
  //           destination: ["Shimla", "Manali"],
  //           days: data?.noOfDays ? Number(data?.noOfDays) : 5,
  //         }),
  //         redirect: "follow",
  //       }
  //     );

  //     const result = await response.json();
  //     setAllTransportData(result.data);
  //     setLoader(false);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setLoader(false);
  //   }
  // };
  const fetchAllTransport = async (data) => {
    setLoader(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/transport-holidays/fetch`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            key: process.env.REACT_APP_BASE_API_KEY,
            Cookie: process.env.REACT_APP_COOKIE,
          },
          body: JSON.stringify({
            //             hub: "Chandigarh",
            // destination: ["Shimla", "Manali"],
            // days: data?.noOfDays ? Number(data?.noOfDays) : 5,
            hub: data?.startDestination
              ? data?.startDestination?.replace(/^Ex\s+/i, "").trim()
              : "Chandigarh",
            destination:
              includingDestinations.length > 0
                ? includingDestinations
                : ["Shimla", "Manali"],
            days: data?.noOfDays ? Number(data?.noOfDays) : 5,
          }),
          redirect: "follow",
        }
      );

      const result = await response.json();
      setAllTransportData(result.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (activeButton === "Hotels") {
      const params = new URLSearchParams(location.search);

      // Get the childAge parameters
      const childAges = [];
      let i = 1;
      while (params.has(`childAge[${i}]`)) {
        childAges.push(params.get(`childAge[${i}]`));
        i++;
      }

      const currentDate = currentDateSingle;

      const data = {
        // hotelID: params.get("hotelID"),
        location: params.get("location"),
        room: params.get("room"),
        adult: params.get("adult"),
        children: params.get("children"),
        checkinDay: new Date(currentDate).getDate(),
        checkinMonth: new Date(currentDate).getMonth() + 1,
        checkinYear: new Date(currentDate).getFullYear(),
        checkoutDay: new Date(currentDate).getDate() + 1,
        checkoutMonth: new Date(currentDate).getMonth() + 1,
        checkoutYear: new Date(currentDate).getFullYear(),
        radio: params.get("radio"),
        childAge: childAges, // Assign the array of child ages
      };
      setBookingData(data);
      fetchAllHotels(data);
    } else if (activeButton === "Packages") {
      const params = new URLSearchParams(location.search);
      const childAges = [];
      let i = 1;
      while (params.has(`childAge[${i}]`)) {
        childAges.push(params.get(`childAge[${i}]`));
        i++;
      }

      const data = {
        location: params.get("location"),
        room: params.get("room"),
        guest: params.get("adult"),
        adult: params.get("guest"),
        children: params.get("children"),
        radio: params.get("radio"),
        childAge: childAges,
      };
      setBookingData(data);
      fetchAllPackages(data);
    } else if (activeButton === "Activities") {
      const params = new URLSearchParams(location.search);
      const childAges = [];
      let i = 1;
      while (params.has(`childAge[${i}]`)) {
        childAges.push(params.get(`childAge[${i}]`));
        i++;
      }

      const data = {
        location: params.get("location"),
        room: params.get("room"),
        adult: params.get("adult"),
        children: params.get("children"),
        radio: params.get("radio"),
        date: params.get("date"),
        year: params.get("year"),
        month: params.get("month"),
        childAge: childAges,
        multiple_destinations: params.get("selected_destinations"),
      };
      setBookingData(data);
      fetchAllActivities(data);
    } else if (activeButton === "Transport") {
      const params = new URLSearchParams(location.search);
      const data = {
        adult: params.get("adult"),
        date: params.get("date"),
        year: params.get("year"),
        month: params.get("month"),
        noOfDays: params.get("noOfDays"),
        startDestination: params.get("startdestination"),
      };

      const travelDate = `${data.year}-${String(data.month).padStart(
        2,
        "0"
      )}-${String(data.date).padStart(2, "0")}`;
      setBookingData({ ...data, travelDate });
      fetchAllTransport(data);

      setDate(travelDate);
      setNoOfDays(data?.noOfDays);
      setStartDestination(data?.startDestination);
      fetchAllTransport(data);
    }
  }, [activeButton, location.search]);

  const renderSearchForm = () => {
    switch (activeButton) {
      case "Packages":
        return <NewUIAgentSearchFormHolidays />;
      case "Hotels":
        return <NewUIAgentSearchFormHotels />;
      case "Activities":
        return <NewUIAgentSearchFormActivity />;
      case "Transport":
        return (
          <NewUIAgentSearchFormTransport
            includingDestinations={includingDestinations}
            setIncludingDestinations={setIncludingDestinations}
          />
        );
      default:
        return null;
    }
  };
  const [markupData, setMarkupData] = useState(null);

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          setMarkupData(findObject || null);
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);

  const calculatePriceWithMarkup = (basePrice) => {
    if (!markupData) return basePrice;

    const { markupType, amount } = markupData;

    if (markupType === "percentage") {
      const percentageAmount = (parseFloat(amount) / 100) * basePrice;
      return basePrice + percentageAmount;
    }

    if (markupType === "fixed") {
      return basePrice + parseFloat(amount);
    }

    return basePrice; // Default fallback
  };

  const navigateToSingleTransport = (item) => {
    navigate(
      `/single-transport-search/${item.packagehandle}?packageId=${
        item?.packageId
      }&startdestination=${startDestination}&noOfDays=${noOfDays}&date=${new Date(
        date
      ).getDate()}&month=${new Date(date).getMonth() + 1}&year=${new Date(
        date
      ).getFullYear()}`,
      {
        state: {
          transportData: item,
          bookingData: bookingData,
          // activityPrice: displayedRate,
          // selectedAddOns: selectedAddOns,
          // totalAddonsCost: totalAddonsCost,
          // totalAddonsCostWithoutCommission: totalAddonsCostWithoutCommission,
          // markupData: markupData,
          // activityPriceWithMarkup, activityPriceWithMarkup,
        },
      }
    );
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedData =
    allHotelsData &&
    allHotelsData &&
    allHotelsData.length > 0 &&
    allHotelsData.slice(startIndex, endIndex);

  const displayedPackagesData =
    allPackagesData &&
    allPackagesData &&
    allPackagesData.length > 0 &&
    allPackagesData.slice(startIndex, endIndex);

  const displayedActivitiesData =
    allActivitiesData &&
    allActivitiesData &&
    allActivitiesData.length > 0 &&
    allActivitiesData.slice(startIndex, endIndex);

  const displayedTransportData =
    allTransportData &&
    allTransportData &&
    allTransportData.length > 0 &&
    allTransportData.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const clearSelection = () => {
    // console.log("Clearing selection...");
  };

  const [truncationMap, setTruncationMap] = useState({});

  useEffect(() => {
    const newMap = {};
    allHotelsData?.slice(0, 6)?.forEach((_, idx) => {
      const el = document.getElementById(`title-${idx}`);
      if (el) {
        newMap[idx] = el.scrollWidth > el.clientWidth;
      }
    });
    setTruncationMap(newMap);
  }, [allHotelsData]);

  return (
    <>
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar />
        <div className="agent-info-container">
          {" "}
          <AgentHeader showSelectProperty={true} vendorProperty={false} />
          <div className={styles.agent_search_page}>
            <section className={styles.agent_search}>
              <div>
                <h4>Search</h4>
                <div className={styles.filter}>
                  {buttons.map((button) => (
                    <button
                      key={button}
                      onClick={() => {
                        setActiveButton(button);
                        navigate("/agent-search");
                      }}
                      className={
                        activeButton === button
                          ? styles.active
                          : styles.filter_item
                      }
                    >
                      {button}
                    </button>
                  ))}
                </div>
                {renderSearchForm()}
              </div>
            </section>
            <section>
              {/* Hotels */}
              <div>
                {" "}
                {loader ? (
                  <div className={styles.hotel_flex_card_sec}>
                    {Array.from({ length: 24 }).map((items, index) => (
                      <div
                        key={index}
                        className={styles.hotel_card}
                        style={{
                          background: "none",
                          marginBottom: "0px",
                          boxShadow:
                            "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                          padding: "0px",
                        }}
                      >
                        <div className={styles.img_sec}>
                          <Skeleton height="100%" width="100%" />
                        </div>
                        <div
                          className="card_content"
                          style={{ marginTop: "0px" }}
                        >
                          <h6>
                            <Skeleton width="40%" />
                          </h6>
                          <h6>
                            <Skeleton width="40%" />
                          </h6>
                          <h6>
                            <Skeleton width="100%" />
                          </h6>
                          <h6>
                            <Skeleton width="24%" />
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    {" "}
                    {activeButton === "Hotels" && (
                      <>
                        {" "}
                        <>
                          {" "}
                          <h3 className="mt-20">Hotels</h3>
                          <div className={styles.hotel_flex_card_sec}>
                            {allHotelsData &&
                              displayedData?.map((items, index) => {
                                const today = new Date(); // Today's date
                                const tomorrow = new Date();
                                tomorrow.setDate(today.getDate() + 1); // Tomorrow's date

                                const checkinDay = today.getDate();
                                const checkinMonth = today.getMonth() + 1; // Month is 0-indexed, so add 1
                                const checkinYear = today.getFullYear();

                                const checkoutDay = tomorrow.getDate();
                                const checkoutMonth = tomorrow.getMonth() + 1; // Month is 0-indexed, so add 1
                                const checkoutYear = tomorrow.getFullYear();
                                return (
                                  <a
                                    onClick={() =>
                                      scroll.scrollToTop({
                                        duration: 500,
                                        smooth: "easeInOutQuad",
                                      })
                                    }
                                    href={`/single-hotel-search/${items?.hotel_slug}/${items?.hotel_id}?location=${items?.hotel_city}&room=1&adult=2&children=0&checkinDay=${checkinDay}&checkinMonth=${checkinMonth}&checkinYear=${checkinYear}&checkoutDay=${checkoutDay}&checkoutMonth=${checkoutMonth}&checkoutYear=${checkoutYear}&hotel_name=${items?.hotel_name}&hotel_address=${items?.hotel_address}`}
                                    key={index}
                                    className={styles.hotel_card}
                                  >
                                    {" "}
                                    <div className={styles.img_sec}>
                                      {items.hotel_image &&
                                      items.hotel_image.length > 0 ? (
                                        <img
                                          src={items?.hotel_image[0]}
                                          alt={items?.alt}
                                        />
                                      ) : (
                                        <img
                                          src={imgNotFound}
                                          alt="Image not found"
                                        />
                                      )}
                                    </div>
                                    <div className={styles.content_sec}>
                                      <div>
                                        {" "}
                                        <span>
                                          {" "}
                                          <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <mask
                                              id="mask0_5983_7301"
                                              style={{ maskType: "alpha" }}
                                              maskUnits="userSpaceOnUse"
                                              x="0"
                                              y="0"
                                              width="18"
                                              height="18"
                                            >
                                              <rect
                                                width="18"
                                                height="18"
                                                fill="#D9D9D9"
                                              />
                                            </mask>
                                            <g mask="url(#mask0_5983_7301)">
                                              <path
                                                d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                                fill="#1C1B1F"
                                              />
                                            </g>
                                          </svg>
                                          {items.hotel_city}
                                        </span>
                                        <div
                                          className={styles.titleContainer}
                                          key={index}
                                        >
                                          <h4
                                            id={`title-${index}`}
                                            className={styles.truncatedTitle}
                                            style={{ padding: "0" }}
                                          >
                                            {items?.hotel_name}
                                          </h4>
                                          {truncationMap[index] && (
                                            <span className={styles.fullTitle}>
                                              {items?.hotel_name}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                      <div>
                                        {" "}
                                        <span
                                          style={{
                                            color: "#666666",
                                            textAlign: "end",
                                          }}
                                        >
                                          {" "}
                                          Starting From
                                        </span>
                                        <h3>
                                          {" "}
                                          {formatIndianCurrency(
                                            items.starting_price
                                          )}
                                        </h3>
                                      </div>
                                    </div>
                                  </a>
                                );
                              })}
                          </div>
                        </>
                        <div className="communication_pagination">
                          {activeButton === "Hotels" && (
                            <CustomPagination
                              currentPage={currentPage}
                              itemsPerPage={itemsPerPage}
                              totalItems={allHotelsData.length}
                              onPageChange={handlePageChange}
                              clearSelection={clearSelection}
                            />
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>

              {/* packages  */}
              <div>
                {loader ? (
                  <div className="container flex align_items_center flex_wrap justify_content_center flex_gap_20 mt-10">
                    {Array.from({ length: 24 }).map((items, index) => (
                      <div
                        key={index}
                        // className="card-listing"
                        className={styles.package_listing_card}
                        style={{
                          background: "none",
                          marginBottom: "0px",
                          boxShadow:
                            "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                          padding: "0px",
                        }}
                      >
                        {/* <div> */}
                        <Skeleton height={200} />
                        {/* </div> */}
                        <div
                          className="card_content"
                          style={{ marginTop: "0px" }}
                        >
                          <h6>
                            <Skeleton width="60%" />
                          </h6>
                          <h6>
                            <Skeleton width="40%" />
                          </h6>
                          <h6>
                            <Skeleton width="100%" />
                          </h6>
                          <Skeleton width="24%" />
                          <h6>
                            <Skeleton width="100%" height="40px" />
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    {activeButton === "Packages" && (
                      <>
                        <h3 className="mt-20">Packages</h3>
                        <div className={styles.package_flex}>
                          {allPackagesData &&
                            allPackagesData.length > 0 &&
                            displayedPackagesData?.map((data, index) => (
                              <NewAgentPackageCard
                                key={index}
                                imgSrc={
                                  data?.featuredImage
                                    ? data?.featuredImage
                                    : imgNotFound
                                }
                                title={data.packageName}
                                packageHub={data.packageHub}
                                duration={data.totalDays}
                                nightDuration={data.totalNights}
                                price={data.startingPrice}
                                bookingLink={data.bookingLink}
                                detailsLink={data.detailsLink}
                                packagehandle={data.packagehandle}
                                canBookable={data?.canBookable}
                                packageId={data.packageId}
                                setShowSendEnquiryPopup={
                                  setShowSendEnquiryPopup
                                }
                                markupData={markupData}
                                NoPax={data?.NoPax}
                                packageItinerary={data?.packageItinerary}
                              />
                            ))}
                        </div>
                        <div className="communication_pagination">
                          {activeButton === "Packages" && (
                            <CustomPagination
                              currentPage={currentPage}
                              itemsPerPage={itemsPerPage}
                              totalItems={allPackagesData.length}
                              onPageChange={handlePageChange}
                              clearSelection={clearSelection}
                            />
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>

              {/* activity */}
              {loader ? (
                Array.from({ length: 12 }).map((items, index) => (
                  <div
                    key={index}
                    className="card-listing"
                    style={{
                      background: "none",
                      borderRadius: "8px",
                      marginBottom: "0px",
                      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                      padding: "0px",
                    }}
                  >
                    <div>
                      <Skeleton
                        style={{ borderRadius: "8px 8px 0px 0px" }}
                        height={150}
                      />
                    </div>
                    <div className="card_content" style={{ marginTop: "0px" }}>
                      <h6>
                        <Skeleton width="60%" />
                      </h6>
                      <h6>
                        <Skeleton width="40%" />
                      </h6>
                      <h6>
                        <Skeleton width="20%" />
                      </h6>
                      <h6>
                        <Skeleton width="24%" />
                      </h6>
                    </div>
                  </div>
                ))
              ) : (
                <>
                  {/* {allActivitiesData?.length > 0 ? (
                    <NoDataFound />
                  ) : ( */}
                  <>
                    {activeButton === "Activities" && (
                      <>
                        <h3 className="mt-20">Activities</h3>
                        <div className={styles.activity_card_flex}>
                          {allActivitiesData &&
                            allActivitiesData.length > 0 &&
                            displayedActivitiesData?.map((data, index) => (
                              <NewAgentActivityCard
                                key={index}
                                imgSrc={
                                  data.featuredImage
                                    ? data.featuredImage
                                    : imgNotFound
                                }
                                title={data.activityName}
                                packageHub={data.packageHub}
                                duration={1}
                                nightDuration={data.totalNights}
                                price={data.startingPrice}
                                bookingLink={data.bookingLink}
                                detailsLink={data.detailsLink}
                                packagehandle={data.packagehandle}
                                canBookable={data?.canBookable}
                                description={data?.content}
                                id={data?.activityId}
                                slug={data?.activityHandle}
                                setShowSendEnquiryPopup={
                                  setShowSendEnquiryPopup
                                }
                                markupData={markupData}
                                sendEnquiry={() => {
                                  // setSelectedActivity(data);
                                  setShowSendEnquiryPopup(true);
                                }}
                                activityDestination={data?.activityDestination}
                              />
                            ))}
                        </div>{" "}
                        <div className="communication_pagination">
                          {activeButton === "Activities" && (
                            <CustomPagination
                              currentPage={currentPage}
                              itemsPerPage={itemsPerPage}
                              totalItems={allActivitiesData.length}
                              onPageChange={handlePageChange}
                              clearSelection={clearSelection}
                            />
                          )}
                        </div>
                      </>
                    )}
                  </>
                  {/* )} */}
                </>
              )}

              {/* transport */}
              {loader ? (
                <Loader size="3em" color="#016937" />
              ) : (
                <>
                  {activeButton === "Transport" &&
                    allTransportData &&
                    allTransportData.length > 0 && (
                      <>
                        <h3 className="mt-20">Transport</h3>
                        <div
                          className={styles.transport_card_flex}
                          style={{ padding: "10px 0" }}
                        >
                          {loader ? (
                            <Loader size="3em" color="#016937" />
                          ) : (
                            <>
                              {allTransportData &&
                              allTransportData.length > 0 ? (
                                <>
                                  {displayedTransportData?.map(
                                    (item, index) => (
                                      <div
                                        className={styles.package_listing_card}
                                        key={index}
                                      >
                                        <div
                                          className={styles.listing_card_data}
                                        >
                                          {" "}
                                          <div className={styles.img_sec}>
                                            {item.featuredImage ? (
                                              <img
                                                src={item.featuredImage}
                                                alt={item.packageName}
                                              />
                                            ) : (
                                              <img
                                                src={imgNotFound}
                                                alt="Image not found"
                                              />
                                            )}
                                          </div>
                                          <div
                                            className={
                                              styles.detail_button_align
                                            }
                                            style={{ padding: "10px 0" }}
                                          >
                                            <div className={styles.content_sec}>
                                              <h3 className="cursor_pointer">
                                                {item?.packageName}{" "}
                                              </h3>
                                              <div className={styles.location}>
                                                <div>
                                                  <svg
                                                    width="14"
                                                    height="15"
                                                    viewBox="0 0 14 15"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <mask
                                                      id="mask0_5990_6365"
                                                      style={{
                                                        maskType: "alpha",
                                                      }}
                                                      maskUnits="userSpaceOnUse"
                                                      x="0"
                                                      y="0"
                                                      width="14"
                                                      height="15"
                                                    >
                                                      <rect
                                                        y="0.5"
                                                        width="14"
                                                        height="14"
                                                        fill="#D9D9D9"
                                                      />
                                                    </mask>
                                                    <g mask="url(#mask0_5990_6365)">
                                                      <path
                                                        d="M9.02596 10.1407L9.64079 9.52584L7.43754 7.32259V4.58325H6.56254V7.67711L9.02596 10.1407ZM7.00106 13.0416C6.23456 13.0416 5.5141 12.8961 4.83967 12.6053C4.16523 12.3144 3.5786 11.9196 3.07975 11.4209C2.5809 10.9223 2.18594 10.3359 1.89485 9.66175C1.60387 8.98761 1.45837 8.26734 1.45837 7.50094C1.45837 6.73444 1.60382 6.01397 1.89471 5.33954C2.1856 4.66511 2.58037 4.07847 3.07902 3.57963C3.57767 3.08078 4.16407 2.68581 4.83821 2.39473C5.51235 2.10374 6.23262 1.95825 6.99902 1.95825C7.76552 1.95825 8.48599 2.1037 9.16042 2.39459C9.83485 2.68547 10.4215 3.08025 10.9203 3.5789C11.4192 4.07755 11.8141 4.66395 12.1052 5.33809C12.3962 6.01222 12.5417 6.73249 12.5417 7.4989C12.5417 8.2654 12.3963 8.98586 12.1054 9.66029C11.8145 10.3347 11.4197 10.9214 10.9211 11.4202C10.4224 11.9191 9.83601 12.314 9.16187 12.6051C8.48774 12.8961 7.76746 13.0416 7.00106 13.0416ZM7.00004 12.1666C8.2931 12.1666 9.39414 11.7121 10.3032 10.803C11.2122 9.89402 11.6667 8.79297 11.6667 7.49992C11.6667 6.20686 11.2122 5.10582 10.3032 4.19679C9.39414 3.28777 8.2931 2.83325 7.00004 2.83325C5.70698 2.83325 4.60594 3.28777 3.69692 4.19679C2.78789 5.10582 2.33337 6.20686 2.33337 7.49992C2.33337 8.79297 2.78789 9.89402 3.69692 10.803C4.60594 11.7121 5.70698 12.1666 7.00004 12.1666Z"
                                                        fill="#1C1B1F"
                                                      />
                                                    </g>
                                                  </svg>
                                                  {item?.totalNights}N/
                                                  {item?.totalDays}D
                                                </div>
                                                <div>
                                                  <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <mask
                                                      id="mask0_5983_7301"
                                                      style={{
                                                        maskType: "alpha",
                                                      }}
                                                      maskUnits="userSpaceOnUse"
                                                      x="0"
                                                      y="0"
                                                      width="18"
                                                      height="18"
                                                    >
                                                      <rect
                                                        width="18"
                                                        height="18"
                                                        fill="#D9D9D9"
                                                      />
                                                    </mask>
                                                    <g mask="url(#mask0_5983_7301)">
                                                      <path
                                                        d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                                        fill="#1C1B1F"
                                                      />
                                                    </g>
                                                  </svg>
                                                  {item.packageHub}
                                                </div>
                                              </div>
                                              {/* <div>
                               <ul>
                                 <div>
                                   {" "}
                                   <li>1N Dharamshala</li>
                                 </div>
                                 <div>
                                   {" "}
                                   <li>2N Kinnour</li>
                                 </div>
                               </ul>
                             </div> */}
                                              <div className={styles.plan}>
                                                <div
                                                  className={`${styles.des_text} text-capitalize`}
                                                >
                                                  Starts:{" "}
                                                  {
                                                    item?.startingPrice
                                                      ?.startCity
                                                  }
                                                </div>
                                                <div className={styles.dots}>
                                                  <div
                                                    className={styles.circle}
                                                  ></div>
                                                  <div className={styles.line}>
                                                    {" "}
                                                  </div>
                                                  <div
                                                    className={styles.circle}
                                                  ></div>
                                                </div>
                                                <div
                                                  className={`${styles.des_text} text-capitalize`}
                                                >
                                                  Ends:{" "}
                                                  {
                                                    item?.startingPrice
                                                      ?.startCity
                                                  }
                                                </div>
                                              </div>{" "}
                                            </div>
                                            <div>
                                              <div
                                                className={
                                                  styles.pricing_details
                                                }
                                              >
                                                {/* <div className={styles.discount_btn}>20% off</div> */}
                                                <div
                                                  className={styles.price_info}
                                                >
                                                  <small>
                                                    Price for{" "}
                                                    <strong className="text-capitalize">
                                                      {
                                                        item?.startingPrice
                                                          ?.vehicleType
                                                      }
                                                    </strong>{" "}
                                                    with Partial AC
                                                  </small>
                                                  <h4>
                                                    {formatIndianCurrency(
                                                      calculatePriceWithMarkup(
                                                        item?.startingPrice
                                                          ?.priceWithoutAC
                                                      )
                                                    )}
                                                  </h4>
                                                </div>
                                              </div>
                                              <button
                                                className={styles.view_btn}
                                                onClick={() =>
                                                  navigateToSingleTransport(
                                                    item
                                                  )
                                                }
                                              >
                                                {" "}
                                                View Details
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </>
                              ) : (
                                <h4>No Data Found</h4>
                              )}
                            </>
                          )}
                        </div>
                        <div className="communication_pagination">
                          {activeButton === "Transport" && (
                            <CustomPagination
                              currentPage={currentPage}
                              itemsPerPage={itemsPerPage}
                              totalItems={allTransportData.length}
                              onPageChange={handlePageChange}
                              clearSelection={clearSelection}
                            />
                          )}
                        </div>
                      </>
                    )}
                </>
              )}
            </section>{" "}
            {showSendEnquiryPopup && (
              <NewSendEnquiryPopup
                package_id={""}
                setshowRatePopup={setShowSendEnquiryPopup}
                typeDetail="package"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewAgentSearchPage;
